import React from 'react';
import { Box } from 'rebass/styled-components';

import { userSelector } from 'redux/selectors';
import { useSelector } from 'react-redux';
import { SettingsLayoutHeader } from '../../../components/atoms/settingsLayoutHeader';
import usePageHook from '../../../hooks/usePageHook';
import LoginInfo from '../../Account/LoginInfo';
import RequestData from '../../Account/RequestData';
import DeleteAccount from '../../Account/DeleteAccount';

const pageTitle = 'Your Getro Account';

export const MyAccount = () => {
  usePageHook(pageTitle);
  const { isOnlyAlly } = useSelector(userSelector);

  return (
    <Box maxWidth="600px">
      <SettingsLayoutHeader title={pageTitle} description="Manage your Getro account." />
      <Box pt="32px">
        <LoginInfo />
        {!isOnlyAlly && <RequestData />}
        {!isOnlyAlly && <DeleteAccount />}
      </Box>
    </Box>
  );
};
